
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.042 80.432"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.989 56.928l-5.236 23.504h-5.347l-5.235-23.504C8.806 53.363.006 41.667.006 28.969-.328 13.708 13.373-.328 29.08.006c15.595 0 28.962 13.367 28.962 28.962 0 12.588-8.8 24.395-21.053 27.96zm11.584-27.96c0-10.694-8.8-19.494-19.494-19.494-10.582 0-19.605 8.8-19.605 19.494 0 10.582 9.023 19.605 19.605 19.605 10.694.001 19.494-9.022 19.494-19.605zm-15.038 0c0 2.562-1.894 4.456-4.456 4.456s-4.456-1.894-4.456-4.456 1.894-4.456 4.456-4.456c2.563.001 4.456 1.894 4.456 4.456z"}})])
          )
        }
      }
    